/**
 * V70G8E — 진행 중 대국이 있는 상태에서 다른 방으로 들어가려 할 때 기권 확인 팝업.
 *   [취소] → 기존 대국 유지 (새 방 진입 안 함)
 *   [기권하고 이동] → 서버 기권 성공 후에만 새 방 진입 (실패 시 오류 표시, 진입 안 함)
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  busy: boolean;
  error: string | null;
  /** 이동하려는 곳 설명 (예: "새 방 만들기", "123456 방 참가", "이 방 관전") */
  targetLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function OmokActiveGameConfirm({ busy, error, targetLabel, onCancel, onConfirm }: Props) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="omok-active-game-title"
      data-testid="omok-active-game-confirm"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 2100,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, maxWidth: 420, width: '100%', boxShadow: '0 10px 40px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <AlertTriangle size={22} color="#b45309" />
          <h2 id="omok-active-game-title" style={{ margin: 0, fontSize: 17, fontWeight: 800, color: '#0f172a' }}>
            진행 중인 대국이 있습니다
          </h2>
        </div>
        <p style={{ margin: '0 0 6px', fontSize: 14, color: '#334155', lineHeight: 1.6 }}>
          <strong>{targetLabel}</strong>(으)로 이동하면 진행 중인 대국은 <strong>기권 처리</strong>되고 상대방 승리로 기록됩니다.
        </p>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748b' }}>
          기권하고 이동하시겠습니까?
        </p>
        {error && (
          <div role="alert" data-testid="omok-active-game-error" style={{ padding: 10, background: '#fee2e2', border: '1px solid #fecaca', borderRadius: 8, color: '#991b1b', fontSize: 13, marginBottom: 12 }}>
            {error}
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            style={{ padding: '9px 16px', background: '#f1f5f9', color: '#334155', border: '1px solid #cbd5e1', borderRadius: 8, cursor: busy ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}
          >취소</button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            style={{ padding: '9px 16px', background: busy ? '#94a3b8' : '#b91c1c', color: '#fff', border: 0, borderRadius: 8, cursor: busy ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 700 }}
          >{busy ? '처리 중…' : '기권하고 이동'}</button>
        </div>
      </div>
    </div>
  );
}
